import React, { Component } from 'react'
import {Dialog, DialogContent, Button, CircularProgress, withStyles} from '@material-ui/core'
import {Grid, GridColumn} from '@progress/kendo-react-grid'
import { FormattedMessage, injectIntl } from 'react-intl';
import NoAuthorization from '../../../helpers/noAuthorization';
import NoSuccess from '../../../helpers/notSuccess';
import MultiSelectFilter from '../../MultiSelectFilter'

const styles = theme=> ({
    gridTable:{
        height:'300px' ,
        marginTop:'7px' , 
        marginBottom: '15px'
    }
})

export class cdShare extends Component {
    constructor(props){
        super(props);
        this.state = {
            data: this.props.dataUsers.data,
            value : []
        }
    }

    deleteRow=(data)=>{
        let array = this.state.value;
        array.splice((data.dataIndex-1),1);
       this.setState({value: array})
    }

    MyButton=(data)=>{
        return(
         <td>
             <div align="right">
             <Button style={{backgroundColor: 'transparent'}} onClick={()=>{this.deleteRow(data)}}>
                 <i className="fas fa-times"/>
             </Button>
             </div>
           
         </td>
        )
     }

     callbackValue=(value)=>{
         this.setState({value: value});
    }

    createArrayValues=(data)=>{
        let array = []
        data.map(field => {
            if(field.companyID === this.props.companyID)
                array.push(this.createObjUser(field))
            return true;
        })
        return array;
    }

    createObjUser=(user)=>{
        this.props.dataUsers.data.map(field => {
            if(field.userID === user.userID) {
                user.name = field.name
            }
            return true;
        })
        return user;
    }

    componentDidMount(){
           if(this.props.selectedData.length !== 0){
               this.setState({value: this.createArrayValues(this.props.selectedData.dashboardShareds)})
           }
    }
    render() {
        const {classes, status, activeForm, showForm, submitting, save} = this.props
        
        let comp = <div></div>
        if(status === 'loading'){comp = <CircularProgress></CircularProgress>}
        else{comp = (
           <React.Fragment>
                <Button className="btn" variant="contained" onClick={showForm }>
                    <FormattedMessage id='cancel' defaultMessage='Cancel' />
                </Button>
                <Button name="save-button" className="btn btn-cyan" color="primary" variant="contained" disabled={status !== 'ready' || submitting }  type="submit" >
                    <FormattedMessage id='save' defaultMessage='Save' />
                </Button>
           </React.Fragment>
        )}
        return (
            <React.Fragment>
               <Dialog
                open={activeForm}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
               >
                <DialogContent>
                    <form onSubmit={(e)=>{ e.preventDefault(); save(this.state.value)}}>
                        <fieldset>
                            <h1><FormattedMessage id="customdash.share" defaultMessage="Share Custom Dashboard" /></h1>
                            
                            { this.props.deniedEdit && <NoAuthorization />}
                            { this.props.requestError && <NoSuccess />}

                            <div className="input-container">
                                <label>{this.props.intl.formatMessage({ id: 'users', defaultMessage: 'Users' })}</label>
                                <MultiSelectFilter 
                                    data={this.state.data} 
                                    dataItemKey="userID"
                                    textField="name"
                                    value= {this.state.value}
                                    send={this.callbackValue}/>
                                    
                                <Grid
                                    className={classes.gridTable}
                                    data={this.state.value}
                                >
                                    <GridColumn field="name" title={this.props.intl.formatMessage({ id: 'name', defaultMessage: 'Name' })}/>
                                    <GridColumn width="30px"    cell={this.MyButton}/>
                                </Grid>
                            </div>
                            
                        </fieldset>
                        <div className="form-actions-btns">
                             <div align="right">
                                {comp}
                             </div>
                        </div>
                    </form>
                </DialogContent>
               </Dialog>
           </React.Fragment>
        )
    }
}

export default withStyles(styles)(injectIntl(cdShare))
